<div class="wrapper-md">
    <app-breadcrumbs [items]="[
                     { url: '/lesson-observations', text: 'lessonObservation_listTitle' },
                     {
                        url: '/lesson-observations/' + (isNew ? 'add' : data?.Id),
                        text: isNew ? 'lessonObservation_newTitle' : 'lessonObservation_editTitle'
                     }]"></app-breadcrumbs>

    <header class="content-header">
        <h1>
            {{(isNew ? 'lessonObservation_newTitle' : 'lessonObservation_editTitle') | translate}}
            <app-lesson-observation-status [value]="data.Status" *ngIf="data"></app-lesson-observation-status>
        </h1>
    </header>

    <form #form="ngForm">
        <app-alert level="danger" *ngIf="data?.ApprovalComment">
            <label>{{'lessonObservation_lblApprovalComment' | translate}}</label>
            <div>{{data.ApprovalComment}}</div>
        </app-alert>

        <div class="block-em">
            <header class="block-header">
                <h5>{{'lessonObservation_lblEvent' | translate}}</h5>
                <aside>
                    <button class="btn"
                            [class.btn-outline]="event"
                            [class.btn-outline-primary]="!event"
                            (click)="$event.preventDefault(); selectEvent()">
                        {{(event ? 'lessonObservation_btnChangeEvent' : 'lessonObservation_btnSelectEvent') | translate}}
                    </button>
                </aside>
            </header>

            <div *ngIf="event" class="mb-3">
                <div>
                    <strong>{{'lessonObservation_lblType' | translate}}</strong>
                    <span class="ms-1">{{event.Type}}</span>
                </div>
                <div>
                    <strong>{{'lessonObservation_lblDate' | translate}}</strong>
                    <span class="ms-1">{{event.Date | appDate}} ({{event.TimeFrom | appTime}} - {{event.TimeTo | appTime}})</span>
                </div>
                <div>
                    <strong>{{'lessonObservation_lblLocation' | translate}}</strong>
                    <span class="ms-1">{{event.Location}}</span>
                </div>
                <div>
                    <strong>{{'lessonObservation_lblSubject' | translate}}</strong>
                    <span class="ms-1">{{event.SubjectCode}} / {{event.SubjectName}}</span>
                </div>
                <div>
                    <strong>{{'lessonObservation_lblProgram' | translate}}</strong>
                    <span class="ms-1">{{event.ProgramCode}} / {{event.ProgramName}} / {{event.ProgramLevel}} / {{event.ProgramType}}</span>
                </div>
            </div>

            <app-alert level="warning" *ngIf="!event">{{'lessonObservation_selectEventWarning' | translate}}</app-alert>
        </div>

        <ng-container *ngIf="event">
            <div class="row">
                <div class="col-md">
                    <div class="form-field required">
                        <label class="form-label"><i class="fi fi-rs-eye d-inline-flex"></i> {{'lessonObservation_lblObserver' | translate}}</label>
                        <app-select [(ngModel)]="observer"
                                    [options]="observers"
                                    [displayFn]="observerDisplayFn"
                                    [required]="true"
                                    [filter]="observerFilterFn"
                                    (selectionChange)="onObserverChange($event)"
                                    name="observer">
                            <ng-template #optionTemplate let-option>
                                <div>{{option.Name}} {{option.Surname}}</div>
                                <div class="text-sub">{{option.Structure}}</div>
                            </ng-template>
                        </app-select>
                    </div>

                    <div class="form-field required">
                        <label class="form-label">{{'lessonObservation_lblObserverStructure' | translate}}</label>
                        <input class="form-control" [value]="observer?.Structure" disabled />
                    </div>

                    <div class="form-field required">
                        <label class="form-label">{{'lessonObservation_lblObserverRole' | translate}}</label>
                        <div *ngFor="let n of roles" class="mb-1">
                            <app-checkbox [(ngModel)]="observerRoleModel[n.Id]" name="observerRole-{{n.Id}}">{{n.Value}}</app-checkbox>

                            <div *ngIf="observerRoleModel[n.Id] && n.Code == 'Other'" class="mt-1 ms-3">
                                <input [(ngModel)]="model.ObserverOtherRole"
                                       class="form-control ng-touched"
                                       maxlength="{{maxLength.otherRole}}"
                                       name="observerOtherRole"
                                       required
                                       [placeholder]="'lessonObservation_lblObserverOtherRole' | translate" />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md">
                    <div class="form-field required">
                        <label class="form-label"><i class="fi fi-rs-graduation-cap d-inline-flex"></i> {{'lessonObservation_lblTeacher' | translate}}</label>
                        <app-select [(ngModel)]="model.TeacherUpn"
                                    [options]="event.Teachers"
                                    [valueProperty]="'Upn'"
                                    [displayFn]="teacherDisplayFn"
                                    [required]="true"
                                    (selectionChange)="onTeacherChange($event)"
                                    name="teacher">
                        </app-select>
                    </div>

                    <div class="form-field required">
                        <label class="form-label">{{'lessonObservation_lblTeacherStructure' | translate}}</label>
                        <app-select [(ngModel)]="model.TeacherStructureId"
                                    [options]="teacherStructures"
                                    [valueProperty]="'Id'"
                                    [displayProperty]="'Name'"
                                    [required]="true"
                                    name="teacherStructure">
                        </app-select>
                    </div>

                    <div class="form-field required">
                        <label class="form-label">{{'lessonObservation_lblTeacherRole' | translate}}</label>
                        <div *ngFor="let n of roles" class="mb-1">
                            <app-checkbox [(ngModel)]="teacherRoleModel[n.Id]" name="teacherRole-{{n.Id}}">{{n.Value}}</app-checkbox>

                            <div *ngIf="teacherRoleModel[n.Id] && n.Code == 'Other'" class="mt-1 ms-3">
                                <input [(ngModel)]="model.TeacherOtherRole"
                                       class="form-control ng-touched"
                                       maxlength="{{maxLength.otherRole}}"
                                       name="teacherOtherRole"
                                       required
                                       [placeholder]="'lessonObservation_lblTeacherOtherRole' | translate" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-field required mt-1">
                <label class="form-label">{{'lessonObservation_lblFormat' | translate}}</label>
                <div>
                    <div class="mb-1">
                        <app-radio [value]="'InPerson'" [(ngModel)]="model.Format" name="format">
                            {{'lessonObservation_formatInPerson' | translate}}
                        </app-radio>
                    </div>

                    <div>
                        <app-radio [value]="'Remote'" [(ngModel)]="model.Format" name="format">
                            {{'lessonObservation_formatRemote' | translate}}
                        </app-radio>
                    </div>
                </div>
            </div>

            <div class="form-field" *ngIf="model.Format == 'Remote'">
                <label class="form-label">{{'lessonObservation_lblFormatNotes' | translate}}</label>
                <textarea class="form-control"
                          [(ngModel)]="model.FormatNotes"
                          rows="2"
                          name="formatNotes"
                          #formatNotesInput="ngModel"></textarea>
                <div class="invalid-feedback" *ngIf="formatNotesInput.errors?.maxlength">
                    {{'fieldError_lengthMinMax' | translate | formatString:[0, maxLength.formatNotes]}}
                </div>
            </div>

            <div class="form-field required">
                <label class="form-label">{{'lessonObservation_lblGoals' | translate}}</label>
                <div>
                    <div *ngFor="let n of goals; let i = index" [class.mt-1]="i > 0">
                        <app-checkbox [ngModel]="model.GoalIds.includes(n.Id)" name="goal-{{n.Id}}" (stateChange)="onGoalChange(n.Id, $event)">{{n.Value}}</app-checkbox>
                    </div>
                </div>
            </div>

            <section class="block">
                <header class="block-header">
                    <h5>{{'lessonObservation_lblObservations' | translate}}</h5>
                </header>

                <div>
                    <div class="form-field required">
                        <label class="form-label">{{'lessonObservation_lblEnvironment' | translate}}</label>
                        <textarea class="form-control"
                                  [(ngModel)]="model.Environment"
                                  rows="5"
                                  name="environment"
                                  required
                                  #environmentInput="ngModel"></textarea>
                        <div class="invalid-feedback" *ngIf="environmentInput.errors?.maxlength">
                            {{'fieldError_lengthMinMax' | translate | formatString:[0, maxLength.environment]}}
                        </div>
                    </div>

                    <div class="form-field required">
                        <label class="form-label">{{'lessonObservation_lblContent' | translate}}</label>
                        <textarea class="form-control"
                                  [(ngModel)]="model.Content"
                                  rows="5"
                                  name="content"
                                  required
                                  #contentInput="ngModel"></textarea>
                        <div class="invalid-feedback" *ngIf="contentInput.errors?.maxlength">
                            {{'fieldError_lengthMinMax' | translate | formatString:[0, maxLength.content]}}
                        </div>
                    </div>

                    <div class="form-field required">
                        <label class="form-label">{{'lessonObservation_lblProcess' | translate}}</label>
                        <textarea class="form-control"
                                  [(ngModel)]="model.Process"
                                  rows="5"
                                  name="process"
                                  required
                                  #processInput="ngModel"></textarea>
                        <div class="invalid-feedback" *ngIf="processInput.errors?.maxlength">
                            {{'fieldError_lengthMinMax' | translate | formatString:[0, maxLength.process]}}
                        </div>
                    </div>

                    <div class="form-field required">
                        <label class="form-label">{{'lessonObservation_lblPerformance' | translate}}</label>
                        <textarea class="form-control"
                                  [(ngModel)]="model.Performance"
                                  rows="5"
                                  name="performance"
                                  required
                                  #performanceInput="ngModel"></textarea>
                        <div class="invalid-feedback" *ngIf="performanceInput.errors?.maxlength">
                            {{'fieldError_lengthMinMax' | translate | formatString:[0, maxLength.performance]}}
                        </div>
                    </div>

                    <div class="form-field required">
                        <label class="form-label">{{'lessonObservation_lblOther' | translate}}</label>
                        <textarea class="form-control"
                                  [(ngModel)]="model.Other"
                                  rows="5"
                                  name="other"
                                  required
                                  #otherInput="ngModel"></textarea>
                        <div class="invalid-feedback" *ngIf="otherInput.errors?.maxlength">
                            {{'fieldError_lengthMinMax' | translate | formatString:[0, maxLength.other]}}
                        </div>
                    </div>

                    <div class="form-field required">
                        <label class="form-label">{{'lessonObservation_lblConclusion' | translate}}</label>
                        <textarea class="form-control"
                                  [(ngModel)]="model.Conclusion"
                                  rows="5"
                                  name="conclusion"
                                  required
                                  #conclusionInput="ngModel"></textarea>
                        <div class="invalid-feedback" *ngIf="conclusionInput.errors?.maxlength">
                            {{'fieldError_lengthMinMax' | translate | formatString:[0, maxLength.conclusion]}}
                        </div>
                    </div>
                </div>
            </section>
        </ng-container>
    </form>

    <div class="form-actions">
        <span class="form-actions-group" *ngIf="event">
            <button class="btn btn-outline-primary" type="button" (click)="save(true)" *ngIf="canSubmit" [disabled]="!form.valid">
                <i class="fi fi-rs-paper-plane"></i>
                {{'submit' | translate}}
            </button>
        </span>

        <span class="form-actions-group">
            <button class="btn btn-outline" type="button" (click)="close()">
                {{(closeBehaviour == 'cancel' ? 'cancel' : 'close') | translate}}
            </button>

            <button class="btn btn-primary" type="button" (click)="save()" [disabled]="!form.valid" *ngIf="event">
                {{'save' | translate}}
            </button>
        </span>
    </div>
</div>
